import { render, staticRenderFns } from "./mdn-signup-popup.vue?vue&type=template&id=ef4a59a6"
import script from "./mdn-signup-popup.vue?vue&type=script&lang=js"
export * from "./mdn-signup-popup.vue?vue&type=script&lang=js"
import style0 from "./mdn-signup-popup.vue?vue&type=style&index=0&id=ef4a59a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports